module.exports = __webpack_public_path__ + "img/PC_02.92a0e59b.jpg";